const ACCOUNT_SHAPE_STORAGE_KEY = 'site-header:account-shape';
const LEGACY_ACCOUNT_SHAPE_STORAGE_KEY = 'beacon:account-shape';

// This hint chooses placeholder geometry only; it must never establish authentication.
export const ACCOUNT_SHAPE_SCRIPT_HTML = {
  __html: `try{if((localStorage.getItem(${JSON.stringify(ACCOUNT_SHAPE_STORAGE_KEY)})??localStorage.getItem(${JSON.stringify(LEGACY_ACCOUNT_SHAPE_STORAGE_KEY)}))==='signed-in')document.documentElement.setAttribute('data-account-signed-in','')}catch(e){}`,
};

export function rememberAccountShape(signedIn: boolean) {
  try {
    window.localStorage.setItem(ACCOUNT_SHAPE_STORAGE_KEY, signedIn ? 'signed-in' : 'signed-out');
  } catch {
    // Blocked storage must not prevent account controls from resolving.
  }
}
